<template>
    <div class="facebook-page card-info">
        <div class="text-left">
            <h5>{{$t('page-available')}}</h5>
            <p>{{$t('active-page')}}</p>
        </div>
        <base-table
            :columns="columns"
            :items="pagesTable"
            :loading="!chargedRemotePages"
        >
            <template #cell(name)="{ item }">
                {{item.attributes.name}} <br> {{item.id}}
            </template>
            <template #cell(actions)="{ item }">
                <button type="button" class="btn btn-primary rounded-pill style-btn" :disabled="loading || haveActivePages" @click="activateRemotePage(item.id)">
                    {{$t('activate')}}
                </button>
            </template>
        </base-table>
   </div>
</template>
<script>

// Internal services js
import { RepositoryFactory } from '../../../repositories/repositoryFactory.js';
import { EventBus }          from '../../../helpers/EventBus.js';
import Alert                 from '../../../helpers/Alert.js';

// Internal components
import BaseTable from '../../../core/components/BaseTable.vue';

// External libraries
import HttpStatus  from 'http-status-codes';
import { mapActions } from 'vuex';

const FacebookPages       = RepositoryFactory.get('FacebookPages');
const FacebookRemotePages = RepositoryFactory.get('FacebookRemotePages');

export default {
    props: ['facebookUsers'],

    components: { BaseTable },

    mounted () {
        // Get active pages.
        this.getActivePages();

        // Get remote pages.
        this.getRemotePages();

        // Listen for the deactivate page event.
        EventBus.$off('deactivate-page');
        EventBus.$on('deactivate-page', () => {
            this.getActivePages();
            this.getRemotePages();
            this.getConnectors();
        });

        // Set first config via the route
        this.firstConfiguration = this.$route.meta.first;
    },

    data () {
        return {
            chargedRemotePages: false,
            pagesTable:         [],
            haveActivePages:    true,
            loading:            false,
            firstConfiguration: false
        };
    },

    computed: {
        columns () {
            return [
                {
                    key:   'name',
                    label: this.$t('page')
                },
                {
                    key:   'attributes.category',
                    label: this.$t('category')
                },
                {
                    key:     'actions',
                    label:   '',
                    thStyle: { width: '160px' },
                    tdClass: 'cell-actions'
                }
            ];
        }
    },

    methods: {
        ...mapActions('core/facebook', [
            'setIsValidAdminToken',
            'setActivePage',
            'setHasActivePage'
        ]),

        /**
         * Methods to get connectors linked to the account
         *
         * getConnectors get connectors linked to account
         */
        ...mapActions('core/connectors', {
            getConnectors: 'index'
        }),

        /**
         * Get all active pages.
         *
         * @returns    void
         */
        getActivePages () {
            FacebookPages.index()
                .then((response) => {
                    this.showActivePage(response);
                });
        },

        /**
         * Get all remote pages.
         *
         * @returns    void
         */
        getRemotePages () {
            if (this.facebookUsers.length === 0) {
                this.chargedRemotePages = true;
                return;
            }

            this.chargedRemotePages = false;
            FacebookRemotePages.index()
                .then((response) => {
                    this.showRemotePages(response);
                });
        },

        /**
         * Show all remote pages
         *
         * @return    void
         */
        showRemotePages (request) {
            this.pagesTable = request.data.data;
            this.chargedRemotePages = true;
        },

        /**
         * Check if we have an active facebook page, so we disable the active button
         * of remote page table
         *
         * @param  {object}  request    The api request
         */
        showActivePage (request) {
            request.data.data.length > 0 ? this.haveActivePages = true : this.haveActivePages = false;
        },

        /**
         * Active remote page
         *
         * @param    {string}    pageId    The id of remote page
         *
         * the api don't have yet a function to get the adminId.
         */
        activateRemotePage (pageId) {
            this.loading = true;
            FacebookPages.create(pageId)
                .then((request) => {
                    this.setIsValidAdminToken({ isValid: request.data.data.attributes['is-remote-access-token-valid'] });
                    this.setActivePage({ activePage: request.data.data });
                    this.setHasActivePage({ hasActivePage: true });
                    this.loading = false;
                    if (this.$router.currentRoute.name.includes('facebook-pages')) {
                        this.$router.push({
                            name: `facebook-connector:${this.$i18n.locale}`
                        });
                    }
                    this.pagesTable = [];
                    this.getRemotePages();

                    EventBus.$emit('activate-page');
                })
                .catch((error) => {
                    if (error.response.status === HttpStatus.UNPROCESSABLE_ENTITY) {
                        Alert.fail(this.$i18n.t(error.response.data.errors[0].detail));
                        this.loading = false;
                    }
                });
        }
    }
};
</script>
